/**
 * Lente de perfil para Analytics → Aterrizaje.
 * Filtra/enfatiza segmentos ya calculados por las RPCs (sin nueva query).
 */

export type ProfileLens = {
    experience: 'all' | 'principiante' | 'intermedio' | 'experto' | 'sin_dato';
    water: 'all' | 'dulce' | 'salada' | 'ambas' | 'sin_dato';
    modality: string; // 'all' | modality key from RPC
};

export const DEFAULT_PROFILE_LENS: ProfileLens = {
    experience: 'all',
    water: 'all',
    modality: 'all',
};

export function isLensActive(lens: ProfileLens): boolean {
    return lens.experience !== 'all' || lens.water !== 'all' || lens.modality !== 'all';
}

const EXPERIENCE_UI: Record<string, string> = {
    principiante: 'Principiante',
    intermedio: 'Intermedio',
    experto: 'Experto',
    sin_dato: 'Sin dato',
};

const WATER_UI: Record<string, string> = {
    dulce: 'Agua dulce',
    salada: 'Agua salada',
    ambas: 'Ambas',
    sin_dato: 'Sin dato',
};

export function describeLens(lens: ProfileLens): string {
    const parts: string[] = [];
    if (lens.experience !== 'all') parts.push(EXPERIENCE_UI[lens.experience] || lens.experience);
    if (lens.water !== 'all') parts.push(WATER_UI[lens.water] || lens.water);
    if (lens.modality !== 'all') parts.push(lens.modality);
    return parts.length ? parts.join(' · ') : 'Todos los perfiles';
}
